import { useMutation } from "@tanstack/react-query"

import { queryClient } from "@/services/tanstackQuery/queryClient"

import { trpcOptions } from "../trpc"

export function useFinishSession(sessionId: string) {
  return useMutation(
    trpcOptions.app.finishSession.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpcOptions.app.getSessionDetail.queryFilter({ sessionId })),
    }),
  )
}
